import request from '@/utils/request'
// 客户分析 analysis
export function analysis(params) {

    return request({
      url: 'api/customer/analysis',
      method: 'get',
      params
    })
  }
//  我的客户
export function mycustomer(params) {

    return request({
      url: 'api/customer/my',
      method: 'get',
      params
    })
  }
//   客户详情 
export function customer(params) {

    return request({
      url: 'api/customer/'+params,
      method: 'get',
      
    })
  }
// /api/readRecord 访问行为
export function readRecord(params) {

    return request({
      url: 'api/readRecord',
      method: 'get',
      params
    })
  }
// api/customer/exist/{id} 客户是否存在
export function customerexist(params) {

  return request({
    url: 'api/customer/exist/'+params,
    method: 'get',
    
  })
}